import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=684bf65a&scoped=true"
import script from "./dialog.js?vue&type=script&lang=js&external"
export * from "./dialog.js?vue&type=script&lang=js&external"
import style0 from "./dialog.scss?vue&type=style&index=0&id=684bf65a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684bf65a",
  null
  
)

export default component.exports